(function(){
  function initHeaderMobile(e){
    const root = e && e.target ? e.target : document;
    const headers = root.querySelectorAll('.site_header');

    headers.forEach((section) => {
      const openBtn = section.querySelector('.mobile-toggle__btn');
      const drawer = section.querySelector('.mobile-drawer');
      const closeBtn = section.querySelector('.mobile-drawer__close');

      if (!openBtn || !drawer) return;

      if (openBtn.__drawerBound) return;
      openBtn.__drawerBound = true;

      const setOpen = (open) => {
        drawer.classList.toggle('is-open', open);
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };

      openBtn.addEventListener('click', (ev) => {
        ev.preventDefault();
        setOpen(!drawer.classList.contains('is-open'));
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', (ev) => {
          ev.preventDefault();
          setOpen(false);
          openBtn.focus();
        });
      }

      section.addEventListener('keydown', (ev) => {
        if (ev.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
      });

      drawer.addEventListener('click', (ev) => {
        if (ev.target === drawer) setOpen(false);
      });
    });

    // Sticky on scroll up behavior
    const header = (root.querySelector && root.querySelector('.site_header')) || document.querySelector('.site_header');
    if (!header || header.__stickyBound) return;
    header.__stickyBound = true;

    let lastY = window.scrollY;
    let ticking = false;
    let lockedByDrawer = false;

    // Optional: add a small, invisible sentinel to know when page is scrolled at all
    const sentinel = document.createElement('div');
    sentinel.setAttribute('data-observer-intercept', '');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.height = '1px';
    sentinel.style.width = '1px';
    sentinel.style.pointerEvents = 'none';
    document.body.prepend(sentinel);

    // Add shadow once not at top
    const io = new IntersectionObserver(([entry]) => {
      header.classList.toggle('header-active', !entry.isIntersecting);
    }, { rootMargin: '0px 0px 0px 0px', threshold: [0, 1] });
    io.observe(sentinel);

    // If mobile drawer opens, keep header visible and stop hiding
    document.addEventListener('click', (ev) => {
      const btn = ev.target.closest && ev.target.closest('.mobile-toggle__btn');
      const drawer = document.querySelector('.mobile-drawer');
      if (btn && drawer) {
        const isOpen = drawer.classList.contains('is-open');
        lockedByDrawer = !isOpen; // About to open
        if (!isOpen) {
          header.classList.remove('header-hidden');
        }
      }
      const close = ev.target.closest && ev.target.closest('.mobile-drawer__close');
      if (close) {
        lockedByDrawer = false;
      }
    }, true);

    const onScroll = () => {
  if (lockedByDrawer) return;

  const y = window.scrollY || 0;

  // Always show at very top
  if (y <= 0) {
    header.classList.remove('header-hidden');
    lastY = 0;
    ticking = false;
    return;
  }

  const delta = y - lastY;
  const minDelta = 6;

  if (Math.abs(delta) > minDelta) {
    if (y >= 80) {
      // Only after 80px scrolled
      if (delta > 0) {
        header.classList.add('header-hidden');   // scrolling down -> hide
      } else {
        header.classList.remove('header-hidden'); // scrolling up -> show
      }
    } else {
      // Before 80px, keep header visible
      header.classList.remove('header-hidden');
    }
    lastY = y;
  }

  ticking = false;
};


    const scrollHandler = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onScroll);
      }
    };

    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', initHeaderMobile);
  document.addEventListener('shopify:section:load', initHeaderMobile);
})();
